export default class Beneficiary
{
    constructor(data, index){
        this.index          = index;
        this.name1          = data.name1;
        this.name2          = data.name2;
        this.name3          = data.name3;
        this.name4          = data.name4;
        this.mother_name    = data.mother_name;
        this.id             = this.getId();
        this.name           = this.getName();
    }

    getId(){
        return this.index + 1;
    }

    getName(){
        return [this.name1, this.name2, this.name3, this.name4].join(' '); 
    }
}